import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import { Glyphicon } from "react-bootstrap";
import _ from "lodash";
import classnames from "classnames";
import moment from "moment";

import styles from "./Table.scss";
import { Mixpanel } from "../../../actions/mixpanel.actions";

class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rows: [],
      sort: _.isEmpty(props.defaultSort) ? {} : props.defaultSort
    };
  }

  render() {
    const { showSubNavIfEmpty } = this.props;
    const isLoading = _.get(
      this.props.table.tables[this.props.name],
      "loading"
    );
    const isTableEmpty = _.isEmpty(this.props.tableData.rows);
    let component = null;

    if (isLoading) {
      component = this.renderSpinner();
    } else if (isTableEmpty && !showSubNavIfEmpty) {
      component = this.renderEmptyMessage();
    } else {
      component = this.renderTable();
    }

    return component;
  }

  renderSpinner() {
    return (
      <div style={{ width: "100%", textAlign: "center", marginTop: "25px" }}>
        Loading...
      </div>
    );
  }

  renderEmptyMessage() {
    return (
      <div style={{ width: "100%", textAlign: "center", marginTop: "25px" }}>
        There are no records for this table
      </div>
    );
  }

  renderTable() {
    const {
      showSubNavIfEmpty,
      isHoverable,
      tableData: { rows }
    } = this.props;
    const isTableEmpty = _.isEmpty(rows);
    const renderEmptyMessage = isTableEmpty && showSubNavIfEmpty;

    const tableBodyClassName = classnames({
      [styles.tableBody]: true,
      [styles.tableBodyHoverable]: isHoverable
    });

    return (
      <React.Fragment>
        <table className={styles.table}>
          {this.renderColgroup()}
          <thead>
            <tr className={styles.tableRow}>{this.renderHeaders()}</tr>
          </thead>
          {!renderEmptyMessage && (
            <tbody className={tableBodyClassName}>{this.renderRows()}</tbody>
          )}
        </table>
        {renderEmptyMessage && this.renderEmptyMessage()}
      </React.Fragment>
    );
  }

  renderColgroup() {
    return (
      this.props.colsConfig && (
        <colgroup>
          {this.props.colsConfig.map((columnWidth, index) => {
            return <col span="1" style={{ width: columnWidth }} key={index} />;
          })}
        </colgroup>
      )
    );
  }

  renderHeaders() {
    return this.props.tableData.headers.map((header, index) => {
      const { align, displayText, id, track, sortDisabled, main } = header;

      const className = classnames({
        [styles.tableHeader]: true,
        [styles.tableHeaderSortDisabled]: sortDisabled,
        [styles.tableHeaderRight]: align === "right",
        [styles.tableHeaderCenter]: align === "center",
        [styles.mainHeader]: main
      });

      return (
        <th
          id={id}
          className={className}
          style={{ whiteSpace: "nowrap" }}
          scope="col"
          key={displayText}
          onClick={() => {
            if (track) Mixpanel.track(track);
            this.sort(index, sortDisabled);
          }}
        >
          {displayText} {this.renderSortArrow(index)}
        </th>
      );
    });
  }

  renderSortArrow(headerIndex) {
    let icon = null;

    if (this.state.sort.headerIndex === headerIndex) {
      const glyph =
        this.state.sort.order === "asc" ? "chevron-up" : "chevron-down";

      icon = <Glyphicon glyph={glyph} />;
    }

    return icon;
  }

  renderRows() {
    const rows = _.isEmpty(this.state.sort)
      ? this.props.tableData.rows
      : this.getRows();

    return rows.map(row => {
      const { data, paused, disabled, overlayComponent, rowKey } = row;

      const rowClassName = classnames({
        [styles.tableRow]: true,
        [styles.tableRowPaused]: paused,
        [styles.tableRowDisabled]: disabled
      });

      let rowElement = null;

      if (row.link) {
        rowElement = (
          <Route
            key={rowKey}
            render={({ history }) => (
              <tr
                key={rowKey}
                className={rowClassName}
                onClick={() => {
                  history.push(row.link);
                }}
              >
                {this.renderRowData(data)}
                {this.renderOverlayComponent(overlayComponent, rowKey)}
              </tr>
            )}
          />
        );
      } else {
        rowElement = (
          <tr key={rowKey} className={rowClassName}>
            {this.renderRowData(data)}
            {this.renderOverlayComponent(overlayComponent, rowKey)}
          </tr>
        );
      }

      return rowElement;
    });
  }

  renderRowData(row) {
    return row.map((rowCell, index) => {
      const tdClassName = classnames({
        [styles.tableData]: true,
        [styles.tableRowCenter]: rowCell.align === "center",
        [styles.bigContent]: rowCell.bigContent
      });
      return (
        <td className={tdClassName} key={index}>
          {rowCell.displayText}
        </td>
      );
    });
  }

  renderOverlayComponent(overlayComponent, rowKey) {
    const overlayPosition = _.get(
      this.props.table.tables[this.props.name],
      "overlayPosition"
    );

    return (
      overlayPosition === rowKey && (
        <td className={styles.tableDataOverlay}>
          <div className={styles.tableDataOverlayRow}>{overlayComponent}</div>
        </td>
      )
    );
  }

  orderRows(headerIndex, order) {
    return _.orderBy(
      this.props.tableData.rows,
      row => {
        let { orderByText } = row.data[headerIndex];

        if (moment(orderByText, "M/D/YYYY", true).isValid()) {
          orderByText = moment(orderByText);
        } else if (_.isString(orderByText)) {
          orderByText = orderByText.toLowerCase();
        }

        return orderByText;
      },
      order
    );
  }

  getRows() {
    const { headerIndex, order } = this.state.sort;

    return this.orderRows(headerIndex, order);
  }

  sort(headerIndex, sortDisabled) {
    if (sortDisabled) return;

    const order =
      this.state.sort.headerIndex === headerIndex &&
      this.state.sort.order === "asc"
        ? "desc"
        : "asc";

    this.setState(() => {
      return {
        rows: this.orderRows(headerIndex, order),
        sort: {
          headerIndex,
          order
        }
      };
    });
  }
}

const mapStateToProps = state => {
  return {
    table: state.table
  };
};

export default connect(mapStateToProps)(Table);



// WEBPACK FOOTER //
// ./src/components/common/table/Table.js